import { User } from 'models';

export const getFirstName = (user: User | null | undefined): string | null => {
  return user?.displayName ? user.displayName.split(' ')[0] : null;
};
